import { ReactNode } from 'react';
import { Stack } from '@common-components';

export const InnerPageFooter = ({ children }: { children: ReactNode }) => (
  <Stack direction="row" gap={1} justifyContent="flex-end">
    {children}
  </Stack>
);
